export default __webpack_public_path__ + "static/media/BootCamp.4b61bcca.png";